import Echo from "laravel-echo";
import Pusher from "pusher-js";
import client from "../api/client";

let echo: Echo<"reverb"> | null = null;

function getAuthToken(): string | null {
  return localStorage.getItem("accessToken");
}

export function getEcho(): Echo<"reverb"> {
  if (echo) return echo;

  echo = new Echo({
    broadcaster: "reverb",
    Pusher,
    key: import.meta.env.VITE_REVERB_APP_KEY || "",
    wsHost: import.meta.env.VITE_REVERB_HOST || "127.0.0.1",
    wsPort: Number(import.meta.env.VITE_REVERB_PORT || 8080),
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME || "http") === "https",
    disableStats: true,
    enabledTransports: ["ws"],
    authEndpoint: "/broadcasting/auth",
    authorizer: (channel: { name: string }) => ({
      authorize: (
        socketId: string,
        callback: (error: unknown, data?: unknown) => void,
      ) => {
        client
          .post("/broadcasting/auth", {
            socket_id: socketId,
            channel_name: channel.name,
          })
          .then((response) => callback(false, response.data))
          .catch((error) => callback(true, error));
      },
    }),
  });

  return echo;
}

export function disconnectEcho(): void {
  if (echo) {
    echo.disconnect();
    echo = null;
  }
}

export function hasActiveToken(): boolean {
  return Boolean(getAuthToken());
}
